import { Injectable } from '@angular/core';
import { FilterParams, RepositoryService } from '../../helpers/crud/repository.service';
import { WancomHttpService } from '../../services/wancom-http/wancom-http.service';
import { WaitingService } from '../layout/waiting/waiting.service';


@Injectable()
export class ColorPaletteService extends RepositoryService<any> {
    constructor(http: WancomHttpService, waiting$: WaitingService) {
        super(http, waiting$, 'colorPalette');
    }

    update(palette: any, newColorPalette: any){

        return this.http.post(`${this.url}/${palette}`, newColorPalette);
    }

    setDefault(palette){
        return this.http.get(`${this.url}/setDefault/${palette.id}`);
    }

}

export class ColorPaletteFilterParams extends FilterParams {
    organizationId?: number;
}
